module.exports = __webpack_public_path__ + "img/21-Emotion.02eda1a1.png";